// extracted by mini-css-extract-plugin
export default {"conflictDateSpan":"G39917d","line":"Gb344b2","modalBody":"Gabe5c1","modalCloseButton":"G8bfcab","modalCloseIcon":"G08f9b7","recipeList":"G5d7443","recipeListItem":"Ga7cc46"};